<template>
    <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-200">
            <tr>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tên công ty
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Số điện thoại
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Email
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Fax
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Website
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Địa chỉ
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Trạng thái
                </th>
                <th
                    scope="col"
                    class="px-6 relative py-3">
                    <span class="sr-only">
                        Edit
                    </span>
                </th>
            </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
            <tr
                v-for="company in companys"
                :key="company.id">
                <td class="px-6 py-4 text-sm font-medium text-gray-900">
                    {{ company.name }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    {{ company.phone }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500">
                    {{ company.email }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    {{ company.fax }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    {{ company.website }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    {{ company.address }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    <hts-dropdown
                        :options="listStatus"
                        :label="company.status"
                        type="text"
                        color="theme"
                        size="large"
                        prop-option-key="id"
                        prop-option-label="action"
                        @click="(action) => dropdownMenuClick(action, company)" />
                </td>
                <td class="px-6 py-4 text-right text-sm font-medium">
                    <hts-form-button
                        type="text"
                        color="info">
                        Edit
                    </hts-form-button>
                </td>
            </tr>
        </tbody>
        <hts-modal
            :show="showPopupChangeStatusCompany"
            title="Change status"
            type="confirm"
            content="Are you sure you want to change status company?"
            @hide="closePopupChangeStatusCompany"
            @confirm="changeStatusCompany('company')" />
    </table>
</template>

<script setup lang="ts">
const companys = ref()
const companyId = ref()
const companyIsSelectedForStatus = ref()
const accessToken = useCookie('AUTH_ACCESS_TOKEN', { default: () => '' })
const showPopupChangeStatusCompany = ref(false)
const listStatus = reactive([
  {
    id: 'active',
    action: 'active'
  },
  {
    id: 'block',
    action: 'block'
  }
])
const api = {
  url: '/company',
  method: 'get',
  headers: {
    Authorization: 'Bearer ' + accessToken.value,
    'hts-workspace': '62f9bbe7adcfab73d748fd92'
  }
}
onMounted(async () => {
  const res: any = await $api(api)
  companys.value = res?.data?.value?.data
})

const dropdownMenuClick = (action: String, company: any) => {
  showPopupChangeStatusCompany.value = true
  companyIsSelectedForStatus.value = action
  companyId.value = company._id
}
const closePopupChangeStatusCompany = () => {
  showPopupChangeStatusCompany.value = false
}
const changeStatusCompany = (company: any) => {
  const id = ref(company._id)
  const api = {
    url: '/company',
    method: 'get',
    headers: {
      Authorization: 'Bearer ' + accessToken.value,
      'hts-workspace': '62f9bbe7adcfab73d748fd92'
    }
  }
}
</script>
